import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "detail-sections row",
  id: "certification"
}
const _hoisted_2 = {
  class: "detail-section column",
  id: "certification-details"
}
const _hoisted_3 = { class: "detail-section-group" }
const _hoisted_4 = {
  class: "detail-section column",
  id: "borrower-details"
}
const _hoisted_5 = {
  class: "detail-section column",
  id: "borrower-details"
}

import CertificationDetails from "@/components/v2/certifications/CertificationDetails.vue";
import Borrower from "@/components/v2/certifications/Borrower.vue";
import { CertificationVM } from "@/types/certifications";


export default /*@__PURE__*/_defineComponent({
  __name: 'Details',
  props: {
    certification: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(CertificationDetails, {
        certificationDetails: __props.certification?.details
      }, null, 8, ["certificationDetails"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(Borrower, {
          borrower: __props.certification?.borrowers?.borrower
        }, null, 8, ["borrower"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(Borrower, {
          borrower: __props.certification?.borrowers?.coBorrower,
          coborrowerDisplayName: 
            __props.certification?.borrowers?.coborrowerDisplayName
          
        }, null, 8, ["borrower", "coborrowerDisplayName"])
      ])
    ])
  ]))
}
}

})